import { DateUtils } from '../app/utils/date.utils';
import { NgbDateUtils } from '../app/utils/ngb-date.utils';
var DateRange = /** @class */ (function () {
    function DateRange() {
    }
    DateRange.buildDateRangeWithBorder = function (fromDate, toDate) {
        var startDate = NgbDateUtils.parseDate(fromDate);
        var endDate = NgbDateUtils.parseDate(toDate);
        var dateRange = new DateRange();
        dateRange.startDate = DateUtils.convertDateToString(startDate, 'yyyy-MM-dd');
        dateRange.endDate = DateUtils.convertDateToString(endDate, 'yyyy-MM-dd');
        return dateRange;
    };
    DateRange.buildDateRangeWithPeriod = function (period) {
        var today = DateUtils.now();
        today.setDate(today.getDate() - 1); // TODO: HANDLE THIS MORE CLEANLY
        var startDate = DateUtils.addPerid(today, -period);
        var dateRange = new DateRange();
        dateRange.startDate = DateUtils.convertDateToString(startDate, 'yyyy-MM-dd');
        dateRange.endDate = DateUtils.convertDateToString(today, 'yyyy-MM-dd');
        return dateRange;
    };
    Object.defineProperty(DateRange.prototype, "formattedEndDate", {
        get: function () {
            return new Date(this.endDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRange.prototype, "formattedStartDate", {
        get: function () {
            return new Date(this.startDate);
        },
        enumerable: true,
        configurable: true
    });
    return DateRange;
}());
export { DateRange };



// WEBPACK FOOTER //
// ./src/models/date-range.ts.pre-build-optimizer.js